import "../../assets/index5.css";
import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { I as x } from "../../chunks/index.ed48ee81.js";
import { m as j } from "../../chunks/make-refs.cb0b9b76.js";
import { c as I } from "../../chunks/index.bddf5ebb.js";
import { forwardRef as N } from "react";
const R = "_buttonQty_1b3eg_1", $ = "_quantity_1b3eg_33", k = "_label_1b3eg_40", w = "_largeQty_1b3eg_74", B = "_selected_1b3eg_81", C = "_large_1b3eg_74", v = "_small_1b3eg_150", e = {
  buttonQty: R,
  quantity: $,
  label: k,
  largeQty: w,
  selected: B,
  large: C,
  small: v
}, J = N(
  ({
    "aria-label": n,
    a11yLabel: m,
    a11yTitle: b,
    className: _,
    disabled: c = !1,
    isDisabled: d = !1,
    isSelected: o = !1,
    label: s,
    quantity: t = 0,
    selectedLabel: l,
    size: a = "medium",
    title: g,
    variant: i = "add",
    ...u
  }, f) => {
    const { $el: y } = j(f, ["$el"]), p = i === "add" ? "24/symbol/plus-bold" : "24/symbol/minus-bold", Q = I(e.buttonQty, _, {
      [e[a]]: a !== "medium",
      [e.selected]: o || t > 0,
      [e.label]: !!s,
      [e.largeQty]: t > 999
    });
    return /* @__PURE__ */ h(
      "button",
      {
        "aria-label": n || m,
        className: Q,
        disabled: c || d,
        ref: y,
        title: g || b,
        type: "button",
        ...u,
        children: [
          (o || t > 0) && /* @__PURE__ */ r("span", { "aria-hidden": !0, className: e.quantity, children: t }),
          !o && t === 0 && !s && /* @__PURE__ */ r(x, { icon: p }),
          (o || t > 0) && l ? l : s
        ]
      }
    );
  }
);
export {
  J as ButtonQuantity
};
//# sourceMappingURL=index.js.map
